import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { StyledScrollContainer } from '../../../../components/StyledScrollContainer';
import { DialogPartsDeliveryConfirmation } from '../../../../components/DialogPartsDeliveryConfirmation';

import {
    Button,
    Typography,
    Card,
} from "@material-tailwind/react";

import { Refresh } from "iconoir-react";

import {
    DeliveryResponse,
    listPartsDeliveryRequest,
} from "../../../../redux/parts/actions";
import { RootState } from '../../../../redux';
import Loader from '../../../../components/Loader';

const TABLE_HEAD = [
    {n: "Tracking", className: "w-20"},
    {n: "Parts", className: ""},
    {n: "VIN", className: ""},
    {n: "YMMT", className: ""},
    {n: "ETA", className: "w-30 text-center"},
    {n: "", className: "w-20"},
];

const DashboardPartsDelivery = () => {
    const dispatch = useDispatch();
    const { deliveries, loading } = useSelector((state: RootState) => state.parts);
    const [selectedDelivery, setSelectedDelivery] = useState<DeliveryResponse | null>(null);
    const [openDialog, setOpenDialog] = useState(false);

    const handleRefresh = () => {
        dispatch(listPartsDeliveryRequest({
            date_from: '',
            date_to: ''
        }));
    };

    useEffect(() => {
        handleRefresh();
    }, [dispatch]);

    const get_parts = (el: DeliveryResponse) => {
        if (!el?.parts)
            return '';
        return el.parts.reduce((acc, value, index) => (acc + (index == 0 ? '' : ', ') + (value?.name || '')), "");
    };

    const get_vin = (el: DeliveryResponse) => {
        if (!el?.parts)
            return '';
        return el.parts.reduce((acc, value, index) => (acc + (index == 0 ? '' : ', ') + (value?.vehicle?.vin || '')), "");
    };

    const get_ymmt = (el: DeliveryResponse) => {
        if (!el?.parts)
            return '';
        return el.parts.reduce((acc, value, index) => (acc + (index == 0 ? '' : ', ') + (value?.vehicle?.ymmt || '')), "");
    };

    return (
        <div className="flex flex-col gap-y-5 mt-5 text-black w-full">
            <Card>
                <Card.Header className="w-full m-0 items-center rounded-none flex  justify-between p-4">
                    <div className="grow">
                        <Typography type="lead" color="default" className="font-semibold mb-1">
                            Parts Deliveries
                        </Typography>
                        <Typography type="small" className="text-foreground block">
                            All expected parts deliveries
                        </Typography>
                    </div>
                    <div className="flex flex-col sm:flex-row items-center w-full shrink-0 gap-3 md:w-max">
                        <Button
                            variant="outline"
                            color="secondary"
                            className="flex items-center gap-2 sm:w-auto w-full"
                            onClick={() => {
                                handleRefresh();
                            }}
                        >
                            <Refresh className="w-4 h-4" />
                        </Button>
                    </div>
                </Card.Header>
                <StyledScrollContainer className="max-h-[400px]">
                    <Card.Body className="p-0 rounded-none">
                        <table className="w-full min-w-max table-auto text-left">
                            <thead>
                                <tr>
                                    {TABLE_HEAD.map((head, idx: number) => (
                                        <th
                                            key={idx}
                                            className={`border-b border-surface p-4 ${head.className}`}
                                        >
                                            <Typography
                                                type="small"
                                                color="default"
                                                className="block font-medium"
                                            >
                                                {head.n}
                                            </Typography>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {deliveries.map((el: DeliveryResponse, idx: number) => (
                                    <tr key={idx} className="group">
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <div className="flex items-center gap-3">
                                                {/*
                                                <Avatar src={el?.thumbnail?.full_url} alt={el.ymmt} shape="rounded" />
                                                  */}
                                                <div className="space-y-1">
                                                    <Typography
                                                        type="small"
                                                        color="default"
                                                        className="font-semibold w-20 whitespace-nowrap overflow-hidden text-ellipsis block"
                                                    >
                                                        {el.delivery_order}
                                                    </Typography>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Typography
                                                type="small"
                                                className="whitespace-nowrap overflow-hidden text-ellipsis block text-foreground"
                                            >
                                                {get_parts(el)}
                                            </Typography>
                                        </td>
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Typography
                                                type="small"
                                                className="whitespace-nowrap overflow-hidden text-ellipsis block text-foreground"
                                            >
                                                {get_vin(el)}
                                            </Typography>
                                        </td>
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Typography
                                                type="small"
                                                className="whitespace-nowrap overflow-hidden text-ellipsis block text-foreground"
                                            >
                                                {get_ymmt(el)}
                                            </Typography>
                                        </td>
                                        <td className="p-4 border-b border-surface group-last:border-none text-center">
                                            <Typography
                                                type="small"
                                                className="whitespace-nowrap overflow-hidden w-30 text-center text-ellipsis block text-foreground"
                                            >
                                                {el.delivery_est_date || "N/A"}
                                            </Typography>
                                        </td>
                                        <td className="p-4 border-b border-surface w-20 group-last:border-none">
                                            <Button
                                                size="xs"
                                                variant="outline"
                                                color="secondary"
                                                className="border-[#E2E8F0]"
                                                onClick={() => {
                                                    setSelectedDelivery(el);
                                                    setOpenDialog(true);
                                                }}
                                            >
                                                Delivered
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Card.Body>
                </StyledScrollContainer>

                <DialogPartsDeliveryConfirmation
                    delivery={selectedDelivery}
                    setIsOpen={setOpenDialog}
                    isOpen={openDialog}
                />
            </Card>

            {loading && <div className="flex justify-center items-center h-full"><Loader /></div>}
        </div>
    );
};

export default DashboardPartsDelivery;
